import { Moment } from 'moment';

export function convertMomentToIsoString(
  date: Moment | undefined,
): string | undefined {
  return date ? date.toDate().toISOString() : undefined;
}
